import React from 'react'

interface LeftoverAmountProps {
    amount: string
}

const LeftoverAmount: React.FC<LeftoverAmountProps> = ({amount}) => {
    return (
        <div className="mt-2">
            <span className="text-blue-01 font-medium font-grotesque">
                {amount} remaining to pay with your card
            </span>
        </div>
    )
}

export default LeftoverAmount
